import React, { useEffect, useRef } from 'react';
import { SvgIcon } from '../../../../../../../common/react/components/SvgIcon';
import { getTranslation } from '../../../../../../../common/react/utils/translations';

export const SearchInput = ({ setDebouncedQuery, isActive, onClick }) => {

    useEffect( () => {
        if (isActive) {
            inputRef.current.focus();
        }
    }, [isActive])

    const inputRef = useRef(null);

    return (
        <div className={'stats-search__input-wrap ' + (isActive ? 'is-active' : '')}>

            <div className='stats-search__input-wrap-inner'>
                <label htmlFor="statsPlayerSearch" className='stats-search__label'>
                    <span className='u-screen-reader'>{ getTranslation( 'label.brownlow.predictor.searchPlayers' ) }</span>
                    <SvgIcon
                        icon={ `search` }
                        className={`stats-search__icon`}
                    />
                </label>
                <input 
                    className='stats-search__input'
                    type='search'
                    autoComplete='off'
                    placeholder={ getTranslation( 'label.brownlow.predictor.searchPlayers' ) }
                    id='statsPlayerSearch'
                    onChange={ e => setDebouncedQuery(e.target.value) }
                    ref={ inputRef }
                />
            </div>

            <button onClick={ onClick } className='stats-search__cancel'>
              { getTranslation( 'label.button.cancel' ) }
            </button>
        </div>
    )
}